(function () {
    'use strict';

    run.admin.parts.rackootsSort = function () {
        const csrf_name = document.getElementsByName('csrf_name')[0].value;
        const csrf_value = document.getElementsByName('csrf_value')[0].value;
        const sort_options = document.getElementById('rackoots_sidebar_sort_options');

        // From Sorty by button (name, etc)
        if (sort_options !== null && sort_options !== 'undefined') {
            const sort_buttons = sort_options.querySelectorAll('button');
            for (let i = 0; i < sort_buttons.length; i++) {
                sort_buttons[i].addEventListener("click", function(e) {
                    const el = e.currentTarget;
                    const sort_params = el.dataset.sortBy.split('-');
                    tinysort('ul#rackoots_nav>li', {data: 'sort-'+sort_params[0], order: sort_params[1]});
                    //saveSortedRackoots();
                });
            }
        }
    }
})();
